import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class OfficePageService {
  
  static getPages(
    pageNumber = 0, 
    pageSize = 10, 
    type
  ) {
    return HttpUtil.get(
      API_ROUTES.OFFICE_PAGES.GET_PAGES
      .replace("<pageSize>", pageSize)
      .replace("<pageNumber>", pageNumber)
      .replace("<type>", type)
    );
  }

  static addPage(payload) {
    return HttpUtil.post(API_ROUTES.OFFICE_PAGES.ADD_PAGE, payload);
  }

  static getActivePage(type) {
    return HttpUtil.get(API_ROUTES.OFFICE_PAGES.GET_ACTIVE_PAGE.replace("<type>", type));
  }
}
